import { useMutation } from '@tanstack/react-query';
import { deleteTransferAudio } from 'services/api/WorkflowServiceAPI';
import { queryClient } from 'services/providers/QueryProvider';
import { queryKeys } from '../queryKeys';

export const useDeleteTransferAudio = () => {
    const { mutateAsync, ...rest } = useMutation({
        mutationFn: (id: string) => deleteTransferAudio(id),
        // The provider default is retry: 1. A delete that reverts config and then
        // removes the object is not worth replaying blind on a failure.
        retry: 0,
        onSuccess: (_data, id) => {
            queryClient.invalidateQueries({ queryKey: queryKeys.workflowConfig(id) });
            // Remove rather than invalidate: the clip query is about to be disabled,
            // so an invalidation never refetches and the deleted blob would be served
            // from cache the moment a new clip is uploaded.
            queryClient.removeQueries({ queryKey: queryKeys.transferAudio(id) });
        },
    });

    return {
        deleteTransferAudio: mutateAsync,
        ...rest,
    };
};
